import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import {
  createActivityApi,
  getLeadActivitiesApi
} from "../../services/activityApi";

import "./LeadActivity.css";

const LeadActivity = () => {
  const { id } = useParams(); // leadId
  const navigate = useNavigate();

  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role;

  const [form, setForm] = useState({
    activity_type: "CALL",
    notes: "",
    status_from: "",
    status_to: "",
    location: ""
  });

  // =========================
  // FETCH ACTIVITIES
  // =========================
  const fetchActivities = async () => {
    try {
      const res = await getLeadActivitiesApi(id);
      setActivities(res.data || []);
    } catch (err) {
      console.log("Fetch Error:", err);
      setActivities([]);
    }
  };

  useEffect(() => {
    fetchActivities();
  }, [id]);

  // =========================
  // INPUT HANDLER
  // =========================
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // =========================
  // CREATE ACTIVITY
  // =========================
  const handleSubmit = async () => {
    try {
      setLoading(true);

      await createActivityApi({
        ...form,
        lead_id: id
      });

      alert("✅ Activity added");

      setForm({
        activity_type: "CALL",
        notes: "",
        status_from: "",
        status_to: "",
        location: ""
      });

      fetchActivities();

    } catch (err) {
      console.log(err);
      alert("Error adding activity");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="activity-container">

      {/* ================= FORM ================= */}
      <div className="activity-form">

        <h3>➕ Add Activity</h3>

        <select
          name="activity_type"
          value={form.activity_type}
          onChange={handleChange}
        >
          <option value="CALL">CALL</option>
          <option value="VISIT">VISIT</option>
          <option value="MEETING">MEETING</option>
          <option value="STATUS_CHANGE">STATUS CHANGE</option>
        </select>

        <input
          name="notes"
          placeholder="Notes"
          value={form.notes}
          onChange={handleChange}
        />

        <input
          name="status_from"
          placeholder="Status From"
          value={form.status_from}
          onChange={handleChange}
        />

        <input
          name="status_to"
          placeholder="Status To"
          value={form.status_to}
          onChange={handleChange}
        />

        <input
          name="location"
          placeholder="Location"
          value={form.location}
          onChange={handleChange}
        />

        <button onClick={handleSubmit} disabled={loading}>
          {loading ? "Saving..." : "Save Activity"}
        </button>

      </div>

      {/* ================= TIMELINE ================= */}
      <div className="activity-timeline">

        <h3>📊 Lead Activity Timeline</h3>

        {activities.length === 0 ? (
          <p>No activity found</p>
        ) : (
          activities.map((a) => (
            <div key={a.id} className="activity-card">

              <h4>{a.activity_type}</h4>

              <p>{a.notes}</p>

              {a.status_from && (
                <p>
                  {a.status_from} → {a.status_to}
                </p>
              )}

              {a.location && (
                <p>📍 {a.location}</p>
              )}

              <small>
                {new Date(a.created_at).toLocaleString()}
              </small>

              {/* ================= VISIT PROOF BUTTON ================= */}
              {a.activity_type === "VISIT" && (
                <button
                  onClick={() =>
                    navigate(
                      `/staff/leads/${id}/activity/${a.id}/proofs`
                    )
                  }
                  style={{
                    marginTop: "8px",
                    padding: "5px 10px",
                    cursor: "pointer"
                  }}
                >
                  📸 Visit Proof
                </button>
              )}

            </div>
          ))
        )}

      </div>

    </div>
  );
};

export default LeadActivity;